export default {
    getRoundTimeLeft({ gameState }) {
        return gameState.round.roundTimeLeft;
    },
    getRoundTimeLeftInSeconds({ gameState }) {
        return gameState.round.roundTimeLeftInSeconds;
    },
};
